import { AvaModule } from './../AvaModule';

export class Module {
    public constructor(init?: Partial<Module>) {
        Object.assign(this, init);
    }

    ModuleId: string;
    ModuleName: string;
    ModuleDescription: string;

    MajorBaseVersion: number;
    MinorBaseVersion: number;

    IsEnabled: boolean;
    IsEditable: boolean;

    static fromAvaModule(module: AvaModule) {
        const m = new this();
        m.ModuleId = module.UniqueId;
        m.ModuleName = module.Name;
        m.ModuleDescription = module.Description;
        m.MajorBaseVersion = 1;
        m.MinorBaseVersion = 0;
        m.IsEnabled = false;
        m.IsEditable = false;
        return m;
    }
}
